import * as common from "./common";
import * as unvisitedPlaces from "./unvisited-places";
import * as unvisitedPlacesNearby from "./unvisited-places-nearby";

export const translations = {
  unvisitedPlaces: {
    pt: {
      ...common.pt,
      ...unvisitedPlaces.pt,
    },
    en: {
      ...common.en,
      ...unvisitedPlaces.en,
    },
    es: {
      ...common.en,
      ...unvisitedPlaces.es,
    },
  },
  unvisitedPlacesNearby: {
    pt: {
      ...common.pt,
      ...unvisitedPlacesNearby.pt,
    },
    en: {
      ...common.en,
      ...unvisitedPlacesNearby.en,
    },
    es: {
      ...common.en,
      ...unvisitedPlacesNearby.es,
    },
  },
};
